module.exports = __webpack_public_path__ + "img/bg-m.b836c93c.png";